export interface S3Marker {
  readonly bucket: string;
  readonly key: string;
  readonly region: string;
}

const DEFAULT_BUCKET = "oppizi-uploads";
const DEFAULT_REGION = "ap-southeast-2";

// Reads the #s3bucket=&s3key=&s3region= marker that PDFImport and useMultiplayerAssets append for re-signing.
export const readS3Marker = (url?: string | null): S3Marker | null => {
  if (!url || !(url.includes("#s3key=") || url.includes("#s3bucket="))) return null;
  const params = new URLSearchParams(url.substring(url.indexOf("#") + 1));
  // get() already decodes; decoding again turned a %20 in the key into a space and the object 404ed (PAD-33408).
  const key = params.get("s3key") || "";
  if (!key) return null;
  return {
    bucket: params.get("s3bucket") || DEFAULT_BUCKET,
    key,
    region: params.get("s3region") || DEFAULT_REGION,
  };
};
